import "./Text.css";
import { useEffect, useRef, type JSX } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { usePreloader } from "../contexts/PreloaderContext";

gsap.registerPlugin(ScrollTrigger);

export function Text({ children, tag = 'p' }: { children: React.ReactNode, tag?: keyof JSX.IntrinsicElements}) {
  const textRef = useRef<HTMLElement>(null);
  const { isComplete } = usePreloader();

  useEffect(() => {
    if (textRef.current && isComplete) {
      gsap.fromTo(
        textRef.current,
        { opacity: 0, y: 15 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: textRef.current,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        },
      );
    }
  }, [isComplete]);

  const Tag = tag as any;

  return (
    <Tag className="__text" ref={textRef}>
      {children}
    </Tag>
  );
}
